/* globals lp */
var Rx = require('ub_wrapped/rx');
var _ = require('lodash');
var ubBanzai = require('ub/control/banzai-features');

var rxUi = window.rxUi;

/*
 * This file is used mixed into Editor (editor.js)
 * it expects this._canvasUIBinding to be defined
 * on the "parent" class it is mixed into.
 *
 */

lp.editor = lp.editor || {};
lp.editor.EditorElementListeners = {
  addElementListeners: function(elm) {
    elm.addListener('mousedown', this.elementMousedownListener);
    elm.addListener('mouseover', this.elementMouseoverListener);
    elm.addListener('mouseout', this.elementMouseoutListener);
    elm.addListener('dblclick', this.elementDblClickListener);

    elm.addListener('shown', this.elementShownListener);
    elm.addListener('hidden', this.elementHiddenListener);
    elm.addListener('moved', this.elementMoveListener);
    elm.addListener('zIndexChanged', this.elementZIndexChangeListener);
    elm.addListener('parentChanged', this.elementContainerChangeListener);
    elm.addListener('orderChanged', this.elementOrderChangeListener);
  },

  removeElementListeners: function(elm) {
    elm.removeListener('mousedown', this.elementMousedownListener);
    elm.removeListener('mouseover', this.elementMouseoverListener);
    elm.removeListener('mouseout', this.elementMouseoutListener);
    elm.removeListener('dblclick', this.elementDblClickListener);

    elm.removeListener('shown', this.elementShownListener);
    elm.removeListener('hidden', this.elementHiddenListener);
    elm.removeListener('moved', this.elementMoveListener);
    elm.removeListener('zIndexChanged', this.elementZIndexChangeListener);
    elm.removeListener('parentChanged', this.elementContainerChangeListener);
    elm.removeListener('orderChanged', this.elementOrderChangeListener);

    if (elm.overlay && elm.overlay.changeEvents) {
      elm.overlay.changeEvents.onCompleted();
      elm.overlay.changeEvents.dispose();
    }
  },

  _shouldIgnoreMouseover: function(evt, elm) {
    var ae = this.activeElement;
    return (evt.shiftKey &&
              (! ae.is('offsetable') ||
                ae === elm ||
                (ae.type === 'lp-multi-select' &&
                  (ae.selection.first().parentElement !== elm.parentElement ||
                  ae.isInSelection(elm))) ||
                ae.parentElement !== elm.parentElement));
  },

  _handleMultiSelectMousedown: function(evt, elm) {
    var ae = this.activeElement;
    if (evt.shiftKey && ae.is('offsetable') && ae !== elm) {
      if (ae.type === 'lp-multi-select' && ae.selection.first().parentElement === elm.parentElement) {
        if (ae.isInSelection(elm)) {
          elm = ae.removeFromSelection(elm);
        } else {
          elm = ae.addToSelection(elm);
        }
      } else if (ae.parentElement === elm.parentElement){
        var o1 = ae.model.getOffset();
        var o2 = elm.model.getOffset();

        var offset = {
          left:Math.min(o1.left, o2.left),
          top:Math.min(o1.top, o2.top)};

        var multiSelect = lp.getModule('lp-multi-select').createElement(
          this.page,
          {
            parentElement:ae.getParentElement(),
            offset:offset,
            size:{width:0, height:0}
          }
        );
        multiSelect.addToSelection(ae);
        multiSelect.addToSelection(elm);
        return multiSelect; // should fire elementMousedown on this
      } else {
        return null;
      }
    }
    return elm;

  },

  createElementListeners: function() {
    var self  = this;

    var _mousedrags = this._canvasUIBinding.source
      .filter(function(ev){
        return (ev.type === 'mousedownElement' &&
                ev.elementType !== 'lp-pom-block' &&
                ev.elementType !== 'lp-pom-root'
               );
      })
      .flatMap(function(ev0){
        return rxUi.observeDrag(null, Rx.Observable.return(ev0))
          .do(function(ev1){
            ev1.elementId = ev0.elementId;
          });
      });

    this._canvasUIBinding.register(_mousedrags);

    this._canvasUIBinding.subscribe(function(ev) {
      //TODO: once we have a cleaner way to register multiple event
      //type subscriptions without creating multiple Rxjs subscribers
      //and accidentally introducting subscription ordering dependencies
      var elm;
      switch (ev.type) {
        case 'mousedownElement':
          elm = self._handleMultiSelectMousedown(
            ev,
            self.page.getElementById(ev.elementId)
          );

          if (elm) {
            if (self.activeElement === null ||
                ! (self.activeElement.type === 'lp-multi-select' &&
                  self.activeElement.isInSelection(elm))) {

                self.setActiveElement(elm);
            }
            self.fireEvent('elementMousedown', { // jui ev
              source: elm,
              // the subscribers rely on the original DOM ev position data being here:
              data: {
                pageX: ev.pageX,
                pageY: ev.pageY
              }
            });
          }
          break;
        case 'mouseoverElement':
          elm = self.page.getElementById(ev.elementId);
          if (! self._shouldIgnoreMouseover(ev, elm)) {
            self.fireEvent('elementMouseover', {source: elm}); // jui ev
          }
          break;
        case 'mouseoutElement':
          elm = self.page.getElementById(ev.elementId);
          self.fireEvent('elementMouseout', {source: elm}); // jui ev
          break;
        case 'doubleClickElement':
          elm = self.page.getElementById(ev.elementId);
          // If the element has a `doubleClick` method, call it
          if (_.isFunction(elm.doubleClick)) {
            elm.doubleClick();
          }
          break;
      }
    });

    Object.extend(this, {
      elementMousedownListener: function(e){
        var elm = e.source;
        var evt = e.data;
        self._canvasUIBinding.onNext({
          type        : 'mousedownElement',
          elementId   : elm.id,
          elementType : elm.type,
          pageX       : Event.pointerX(evt),
          pageY       : Event.pointerY(evt),
          shiftKey    : evt.shiftKey,
          ctrlKey     : evt.ctrlKey,
          metaKey     : evt.metaKey
        });
      },

      elementDblClickListener: function(e){
        var elm = e.source;

        self._canvasUIBinding.onNext({
          type        : 'doubleClickElement',
          elementId   : elm.id
        });
      },

      elementMouseoverListener: function(e){
        var elm = e.source;
        // e is a jui event. e.data is the dom event
        self._canvasUIBinding.onNext({
          type      : 'mouseoverElement',
          elementId : elm.id,
          shiftKey  : e.data.shiftKey
        });
      },

      elementMouseoutListener: function(e){
        var elm = e.source;
        // e is a jui event. e.data is the dom event
        self._canvasUIBinding.onNext({
          type      : 'mouseoutElement',
          elementId : elm.id,
          shiftKey  : e.data.shiftKey
        });
      },

      // rest are plain jui events, not wrapping DOM events:
      elementShownListener: function(e){
        self.fireEvent('elementShown', e);
      },

      elementHiddenListener: function(e){
        self.fireEvent('elementHidden', e);
      },

      elementMoveListener: function(){
        self.updateControlStates();
      },

      elementZIndexChangeListener: function(e){
        self.updateControlStates();
        self.fireEvent('elementZIndexChanged', e);
      },

      elementContainerChangeListener: function(e){
        self.fireEvent('elementContainerChanged', e);
      },

      elementOrderChangeListener: function(e){
        if ( ! ubBanzai.features.isSkipPageUpdateAndRefreshOnReorderEnabled() ) {
          self.page.updateAndRefresh();
        }
        self.fireEvent('elementOrderChanged', e);
      }
    });
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/editor-element-listeners.js
// module id = 736
// module chunks = 0